import { ExternalLinkIcon, InfoIcon, XIcon } from 'lucide-react'
import { Box, Callout, IconButton, Link, Text } from '@radix-ui/themes'
import { useState } from 'react'

export const LegacyVersionCallout = () => {
  const [isVisible, setIsVisible] = useState(
    sessionStorage.getItem('com.veekls.legacyVersionCallout.dismissed') !== 'true'
  )

  if (!isVisible) {
    return null
  }

  return (
    <Box px="4" mb="4">
      <Callout.Root color="gray" style={{ position: 'relative' }} size="1">
        <Callout.Icon>
          <InfoIcon />
        </Callout.Icon>
        <Callout.Text>
          <Text>Si prefieres, puedes </Text>
          <Link href="https://v1.veekls.com" target="_blank" size="2">
            <Text mr="1">ir a la version anterior</Text>
            <ExternalLinkIcon />
          </Link>
          <IconButton
            style={{ position: 'absolute', top: '1em', right: '1em' }}
            variant="ghost"
            onClick={() =>
              setIsVisible(() => {
                sessionStorage.setItem('com.veekls.legacyVersionCallout.dismissed', 'true')

                return false
              })
            }
          >
            <XIcon />
          </IconButton>
        </Callout.Text>
      </Callout.Root>
    </Box>
  )
}
